import React, { useEffect, useState, useRef, useContext } from "react";
import { TableHeader } from "../../../components/table/TableHeader";
import { AiOutlineSearch, AiOutlineCloseCircle } from "react-icons/ai";
import Head from "next/head";
import ScrollableTable from "../../../components/table/ScrollableTable";
import WinningMetrics from "../../../components/WinningMetrics";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import useInfiniteScroll from "../../../components/hooks/useInfiniteScroll";
import useWindowResize from "../../../components/hooks/useWindowResize";
import Link from "next/link";
import { useRouter } from "next/router";
import { AppContext } from "../../../context/state";
import Utils from "../../../utils/Utils";
import { authGetRequest } from "../../../utils/authGetRequest";
import Input from "../../../components/form/Input";
import MainLayout from "../../../components/MainLayout/MainLayout";
import { useCookies } from "react-cookie";
import logoNBA from "../../../assets/images/League_NBA.png";
import logoNCAA from "../../../assets/images/League_NCAA.png";
import WNBALogo from "../../../assets/images/WNBALogo.png";
import SQBestBetsSreenshot from "../../../assets/images/SQBestBetsSreenshot.png";
import { Col, Form, InputGroup, Row, Button } from "react-bootstrap";
import { appServerSideProps } from "../../../utils/getAppService";
import { getDefYear } from "../../../constants/main";
let ascOrder = true;

const bettingResultsHeader = [
  {
    title: "Team",
    showImage: false,
    sortable: true,
    key: "team",
  },
  {
    title: "Record",
    showImage: false,
    sortable: false,
    key: "Record",
  },
  {
    title: "SQ Record",
    showImage: false,
    sortable: false,
    key: "SQ Record",
  },
  {
    title: "Win%",
    showImage: false,
    sortable: true,
    key: "win_pct",
  },
  {
    title: "SQ Win%",
    showImage: false,
    sortable: true,
    key: "sq_win_pct",
  },
  {
    title: "Cover%",
    showImage: false,
    sortable: true,
    key: "cover_pct",
  },
  {
    title: "SQ Cover%",
    showImage: false,
    sortable: true,
    key: "sq_cover_pct",
  },
  {
    title: "Over Win %",
    showImage: false,
    sortable: true,
    key: "over_win_pct",
  },
  {
    title: "SQ Over Win%",
    showImage: false,
    sortable: true,
    key: "sq_over_win_pct",
  },
  {
    title: "Under Win %",
    showImage: false,
    sortable: true,
    key: "under_win_pct",
  },
  {
    title: "SQ Under Win %",
    showImage: false,
    sortable: true,
    key: "sq_under_win_pct",
  },
  {
    title: "Favorite Win",
    showImage: false,
    sortable: true,
    key: "fav_win",
  },
  {
    title: "SQ Favorite Win",
    showImage: false,
    sortable: true,
    key: "sq_fav_win",
  },
  {
    title: "Underdog Win",
    showImage: false,
    sortable: true,
    key: "under_win",
  },
  {
    title: "SQ Underdog Win",
    showImage: false,
    sortable: true,
    key: "sq_under_win",
  },
];

const BettingRecord = () => {
  const router = useRouter();
  let leagueFromUrl = router.query?.league;
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [user, setUser] = useState(null);
  const [domLoaded, setDomLoaded] = useState(false);
  const [authToken, setAuthToken] = useState(null);
  const [cookies, setCookie] = useCookies(["token_access, name"]);
  const { store, setStore } = useContext(AppContext);
  const [bettingData, setBettingData] = useState([]);
  const [rawBettingData, setRawBettingData] = useState([]);
  const [year, setYear] = useState(getDefYear(leagueFromUrl));
  const [sortedKey, setSortedKey] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const bettingTableRef = useRef();
  const inputSearchRef = useRef(null);
  const windowSize = useWindowResize();
  const [displaySearchResults, setDisplaySearchResults] = useState(false);
  const [searchAutocomplete, setSearchAutocomplete] = useState({
    team: [],
    conference: [],
  });

  if (leagueFromUrl === "ncaa") {
    leagueFromUrl = "college_mens";
  }

  let bettingHeader = bettingResultsHeader;
  if (store.leagueType === "wnba" || leagueFromUrl === "wnba") {
    bettingHeader = bettingHeader.filter((item) => item.key !== "Conference");
  }

  const [bettingSlicedArray] = useInfiniteScroll({
    array: bettingData,
    scrollType: windowSize?.["width"] > 768 ? "window" : "parent",
    parentRef: bettingTableRef,
    itemsPerView: user ? 40 : 15,
  });
  const searchBettingDataByTeam = (searchTerm) => {
    return Array.from(
      new Set(
        rawBettingData
          .filter((team) => team["team"]?.toLowerCase().includes(searchTerm.toLowerCase()))
          .map((team) => team["team"])
      )
    );
  };
  const searchBettingDataByConference = (searchTerm) => {
    return Array.from(
      new Set(
        rawBettingData
          .filter((team) => team["conference"]?.toLowerCase().includes(searchTerm.toLowerCase()))
          .map((team) => team["conference"])
      )
    );
  };
  const searchBettingData = (searchTerm, searchType) => {
    let newBettingRecords;
    if (searchType === "team") {
      newBettingRecords = bettingData.filter((r) => r["team"] === searchTerm);
    } else {
      newBettingRecords = bettingData.filter((r) => r["conference"] === searchTerm);
    }
    return newBettingRecords;
  };
  const clearSearch = (e) => {
    setSearchKey("");
    setBettingData(rawBettingData);
    inputSearchRef.current.value = "";
    setDisplaySearchResults(false);
  };
  const handleInputChange = (e) => {
    if (e.target.value.length > 0) {
      setSearchKey(e.target.value);
      setDisplaySearchResults(true);
    }
  };
  const displaySearchData = (e, searchType) => {
    inputSearchRef.current.value = e.target.innerText;
    setSearchKey(e.target.innerText);
    setBettingData([...searchBettingData(e.target.innerText, searchType)]);
    setDisplaySearchResults(false);
  };

  useEffect(() => {
    setSearchAutocomplete({
      team: searchBettingDataByTeam(searchKey).splice(0, 5),
      conference: searchBettingDataByConference(searchKey).splice(0, 5),
    });
  }, [searchKey, setSearchKey]);

  const sort = (key) => {
    let res = [];
    let rawData = rawBettingData;
    let replaceKey;
    const headerObj = bettingHeader.filter((column) => column["key"] === key)[0];
    replaceKey = headerObj["key"];
    let keySumm = {};
    if (sortedKey === key) {
      let order = ascOrder ? "asc" : "desc";
      res = rawData.sort(Utils.dynamicsort(replaceKey, order, keySumm));
      ascOrder = order === "desc";
    } else {
      ascOrder = false;
      setSortedKey(key);
      res = rawData.sort(Utils.dynamicsort(replaceKey, null, keySumm));
    }
    setBettingData([...res]);
  };

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("user")));
    if (document.cookie.includes("token_access")) {
      setAuthToken(document.cookie.split("token_access=").pop().split(";").shift());
    }

    document.title = "ShotQuality | Betting Record";
    setDomLoaded(true);
    ascOrder = true;
  }, []);

  useEffect(() => {
    if (leagueFromUrl) {
      setStore({ ...store, leagueType: leagueFromUrl });
    }
    // async function load() {
    if (authToken) {
      authGetRequest(`/api/${leagueFromUrl ? leagueFromUrl : store.leagueType}/trend-finder/team-standings`, authToken)
        .then((response) => {
          return response.data;
        })
        .then((response) => {
          setBettingData(response.data);
          setRawBettingData(response.data);
          setIsDataLoaded(true);
        })
        .catch(async (err) => {
          if (err.message.includes("401")) {
            try {
              const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
                body: authToken,
              })
                .then((res) => res.json())
                .then((response) => {
                  setCookie("token_access", response.access_token);
                  setAuthToken(response.access_token);
                });
            } catch (error) {
              console.log(error);
            }
          }
          console.log("Request failed :(");
        })
        .finally(() => {
          setIsDataLoaded(true);
        });
    }
  }, [leagueFromUrl, store.leagueType, authToken]);

  return (
    <>
      <Head>
        <title>
          {`${leagueFromUrl === "college_mens" ? "NCAA" : leagueFromUrl.toUpperCase()} Basketball Betting Record`}
        </title>
        <meta
          name="description"
          content={`Maximize your wins with ShotQualityBets ${
            leagueFromUrl === "college_mens" ? "NCAA" : leagueFromUrl.toUpperCase()
          } Betting Trends Analysis! Check out our unbeatable Betting Record page for data-backed predictions and historical performance. Bet smarter, not harder!.`}
        />
      </Head>
      <MainLayout>
        <main id="ContentBox" style={{ minHeight: "100vh", position: "relative" }}>
          <div className="MiscStats">
            {/* Start Title side */}
            <div className=" text-center">
              <div className="container-fluid">
                <div className="dukescroe">
                  <div className="row flex flex-column align-items-center header-container">
                    <div className="box col-md-8  d-flex justify-content-center align-items-center">
                      {bettingData.length > 0 ? (
                        <h2 className="teamStandingsTitle">
                          {" "}
                          <img
                            style={
                              store.leagueType === "wnba"
                                ? { marginRight: "0px", marginLeft: "24px", marginTop: "5px" }
                                : { marginTop: "2px" }
                            }
                            src={
                              store.leagueType === "nba"
                                ? logoNBA.src
                                : store.leagueType === "wnba"
                                ? WNBALogo.src
                                : logoNCAA.src
                            }
                            width="80px"
                            height="80px"
                            alt="selected League"
                          />{" "}
                          {store.leagueType === "nba" ? "NBA" : store.leagueType === "wnba" ? "WNBA" : "NCAA"} Betting
                          record
                        </h2>
                      ) : (
                        <SkeletonTheme color="#a4abb3" highlightColor="#e3e6e8">
                          <Skeleton height="39px" width="300px" />
                        </SkeletonTheme>
                      )}
                    </div>
                    {domLoaded && window.innerWidth > 375 && (
                      <div className="box col-md-4 text-md-right position-relative">
                        {bettingData.length > 0 ? (
                          <div className="search position-relative w-100">
                            <Input
                              icon={<AiOutlineSearch />}
                              type="text"
                              placeholder="Search Team/Conference"
                              className="form-control w-100 search-input"
                              ref={inputSearchRef}
                              onInput={handleInputChange}
                              rightIcon={
                                inputSearchRef?.current?.value.length > 0 ? (
                                  <AiOutlineCloseCircle onClick={clearSearch} />
                                ) : null
                              }
                            />
                            {displaySearchResults === true ? (
                              <div className="search-results">
                                <h6 className="text-left -2">Teams</h6>
                                {searchAutocomplete["team"].length > 0 ? (
                                  searchAutocomplete["team"].map((searchTerm) => (
                                    <span
                                      key={searchTerm}
                                      className="search-results__text"
                                      onClick={(e) => displaySearchData(e, "team")}
                                    >
                                      {searchTerm}
                                    </span>
                                  ))
                                ) : (
                                  <span disabled="true" className="text-center">
                                    No Results Found
                                  </span>
                                )}
                                <h6 className="text-left -2">Conferences</h6>
                                {searchAutocomplete["conference"].length > 0 ? (
                                  searchAutocomplete["conference"].map((searchTerm) => (
                                    <span
                                      key={searchTerm}
                                      className="search-results__text"
                                      onClick={(e) => displaySearchData(e, "conference")}
                                    >
                                      {searchTerm}
                                    </span>
                                  ))
                                ) : (
                                  <span disabled="true" className="text-center">
                                    No Results Found
                                  </span>
                                )}
                              </div>
                            ) : null}
                          </div>
                        ) : (
                          <SkeletonTheme color="#a4abb3" highlightColor="#e3e6e8">
                            <Skeleton height="39px" width="100%" style={{ borderRadius: "30px" }} />
                          </SkeletonTheme>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* End Title side */}
            {/* Start Score side */}
            <div className="Scoreside text-center mt-5">
              <div className="container-fluid">
                <div className="dukescroe">
                  {domLoaded && window.innerWidth <= 375 && (
                    <div className="box col-md-4 mb-4 text-md-right position-relative">
                      {bettingData.length > 0 ? (
                        <div className="search position-relative w-100">
                          <Input
                            icon={<AiOutlineSearch />}
                            type="text"
                            placeholder="Search Team/Conference"
                            className="form-control w-100 search-input"
                            ref={inputSearchRef}
                            onInput={handleInputChange}
                            rightIcon={
                              inputSearchRef?.current?.value.length > 0 ? (
                                <AiOutlineCloseCircle onClick={clearSearch} />
                              ) : null
                            }
                          />
                          {displaySearchResults === true ? (
                            <div className="search-results">
                              <h6 className="text-left -2">Teams</h6>
                              {searchAutocomplete["team"].length > 0 ? (
                                searchAutocomplete["team"].map((searchTerm) => (
                                  <span
                                    key={searchTerm}
                                    className="search-results__text"
                                    onClick={(e) => displaySearchData(e, "team")}
                                  >
                                    {searchTerm}
                                  </span>
                                ))
                              ) : (
                                <span disabled="true" className="text-center">
                                  No Results Found
                                </span>
                              )}
                              <h6 className="text-left -2">Conferences</h6>
                              {searchAutocomplete["conference"].length > 0 ? (
                                searchAutocomplete["conference"].map((searchTerm) => (
                                  <span
                                    key={searchTerm}
                                    className="search-results__text"
                                    onClick={(e) => displaySearchData(e, "conference")}
                                  >
                                    {searchTerm}
                                  </span>
                                ))
                              ) : (
                                <span disabled="true" className="text-center">
                                  No Results Found
                                </span>
                              )}
                            </div>
                          ) : null}
                        </div>
                      ) : (
                        <SkeletonTheme color="#a4abb3" highlightColor="#e3e6e8">
                          <Skeleton height="39px" width="100%" style={{ borderRadius: "30px" }} />
                        </SkeletonTheme>
                      )}
                    </div>
                  )}
                  <ScrollableTable top="0px" ref={bettingTableRef}>
                    {!authToken && (
                      <div className="col-md-12 dummyLockWrapper">
                        <div className="imgWrapper">
                          <img src={SQBestBetsSreenshot.src} className="bracketBackground" alt="" />
                        </div>

                        <Col
                          className="dummyLock"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            position: "absolute",
                            top: "20px",
                            left: "50%",
                            transform: "translateX(-50%)",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flexDirection: "column",
                            }}
                          >
                            <h3>Sign in to See More</h3>
                            <div style={{ color: "#6B6C72" }}>
                              The Shot Quality Betting Model is a proven betting system. Using advanced predictive data,
                              it returned a 53.5% win rate and $6200 to a $100 bettor last season.
                            </div>
                            <Link href={"/login"}>
                              <button className="btn btn-dummy btn-lg min-width-236px">Sign in</button>
                            </Link>
                            <div
                              style={{
                                display: "flex",
                                fontSize: 18,
                                fontWeight: 600,
                                flexDirection: "row",
                                marginTop: 40,
                              }}
                            >
                              <div
                                style={{
                                  color: "#0F131B",
                                  fontSize: 18,
                                  fontWeight: 600,
                                  flexDirection: "row",
                                }}
                              >
                                Already have an account?
                              </div>
                              <Link href={"/login#login"} onClick={Utils.setPreLoginUrl}>
                                <div
                                  style={{
                                    color: "#F26B0B",
                                    marginLeft: 10,
                                    textDecoration: "underline",
                                  }}
                                >
                                  Sign In
                                </div>
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </div>
                    )}
                    {bettingData.length > 0 && (
                      <div className="table-responsive table-space">
                        <table className="table tl-fixed-desktop position-relative">
                          <thead style={{ zIndex: 9, background: "none" }}>
                            <tr>
                              {bettingData.length > 0 ? (
                                <TableHeader
                                  headers={bettingHeader}
                                  onSortClick={sort}
                                  ascOrder={ascOrder}
                                  sortedKey={sortedKey}
                                />
                              ) : null}
                            </tr>
                          </thead>
                          <tbody>
                            {bettingSlicedArray.map((data, i) => {
                              return (
                                <tr key={"teamsconf" + i}>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title={data["team"]}
                                  >
                                    {" "}
                                    <Link href={`/team/${store.leagueType}/${year}/${data["team"]}`} target={"_blank"}>
                                      {data["team"]}
                                      {store.leagueType !== "wnba" && (
                                        <>
                                          <br />({data["conference"]})
                                        </>
                                      )}
                                    </Link>
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      // fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title="Record"
                                  >
                                    {" "}
                                    {data["wins"]} {"-"}
                                    {data["losses"]}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      // fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title="SQ Record"
                                  >
                                    {" "}
                                    {data["sq_wins"]} {"-"}
                                    {data["sq_losses"]}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      // fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title="Win%"
                                  >
                                    {" "}
                                    {Utils.toPercent(data["win_pct"])}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      // fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title="SQWin%"
                                  >
                                    {" "}
                                    {Utils.toPercent(data["sq_win_pct"])}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      // fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title="Cover%"
                                  >
                                    {" "}
                                    {Utils.toPercent(data["cover_pct"])}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      // fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title="SQ Cover%"
                                  >
                                    {" "}
                                    {Utils.toPercent(data["sq_cover_pct"])}
                                  </td>

                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      // fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title="Over Win%"
                                  >
                                    {" "}
                                    {Utils.toPercent(data["over_win_pct"])}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      // fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title="SQ Over Win%"
                                  >
                                    {" "}
                                    {Utils.toPercent(data["sq_over_win_pct"])}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      // fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title="Under Win%"
                                  >
                                    {" "}
                                    {Utils.toPercent(data["under_win_pct"])}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      // fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title="SQ Under Win%"
                                  >
                                    {" "}
                                    {Utils.toPercent(data["sq_under_win_pct"])}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      // fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title="Fav win"
                                  >
                                    {" "}
                                    {data["fav_w"] + "-" + data["fav_l"]}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      // fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title="SQ Fav win"
                                  >
                                    {" "}
                                    {data["sq_fav_w"] + "-" + data["sq_fav_l"]}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      // fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title="UnderDog win"
                                  >
                                    {" "}
                                    {data["dog_w"] + "-" + data["dog_l"]}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      fontFamily: "var(--font-inter)",
                                      fontSize: "14px",
                                      // fontWeight: 700,
                                      color: "#0F131B",
                                    }}
                                    title="SQ UnderDog win"
                                  >
                                    {" "}
                                    {data["sq_dog_w"] + "-" + data["sq_dog_l"]}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                        {/* {isDataLoaded && bettingData.length === 0 && leagueFromUrl === "nba" && (
                          <div style={{ width: "100%", display: "flex", "justify-content": "center" }}>
                            <h4>
                              {" "}
                              🧠 The ShotQuality{" "}
                              {store.leagueType.toLowerCase() === "college_mens"
                                ? "NCAA"
                                : store.leagueType.toUpperCase()}{" "}
                              Model is Learning.{" "}
                              {store.leagueType.toLowerCase() === "college_mens"
                                ? "NCAA"
                                : store.leagueType.toUpperCase()}{" "}
                              Records will be available in 2-4 weeks
                            </h4>
                          </div>
                        )} */}
                        {isDataLoaded && bettingData.length === 0 && (
                          <h3 style={{ margin: "0 auto" }}>
                            There are no upcoming{" "}
                            {leagueFromUrl.toLowerCase() === "nba"
                              ? "NBA"
                              : leagueFromUrl.toLowerCase() === "wnba"
                              ? "WNBA"
                              : "College Mens"}{" "}
                            games available.{" "}
                          </h3>
                        )}
                      </div>
                    )}
                  </ScrollableTable>
                  <div style={{ borderBottom: "5px solid orange", paddingTop: "20px" }}></div>
                  <WinningMetrics targetPage={"BettingRecord"} />
                </div>
              </div>
              {/* End Score side */}
              {/* Start Dummy side */}
              <div className="Dummyside">
                <div className="container"></div>
              </div>
            </div>
          </div>
        </main>
      </MainLayout>
    </>
  );
};

export default BettingRecord;
export const getServerSideProps = appServerSideProps(async ({ appService }) => {
  const isUserLogged = appService.getUser();

  let user = null;

  if (isUserLogged) {
    user = await appService.get("api/account");
  }
  if (Utils.isTrader(user)) {
    return {
      redirect: {
        destination: "/trader-dashboard",
        permanent: false,
      },
    };
  }
  return { props: { user } };
});
